import {
  fetchTransactions,
  depositFunds,
  withdrawFunds,
  flexiPay,
  flexiQuick,
  quickFlexi,
  shareFlexi,
} from "@/api/transactionService";

export default {
  //Fetch transactions
  async fetchTransactions({ commit }, pageNumber) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });

      const response = await fetchTransactions(pageNumber);
      const transactions = response.data.data;
      commit("SET_TRANSACTION_DATA", transactions);
      commit("SET_TRANSACTIONS_RECORDS", response.data.data.totalRecords);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Your transactions loaded.",
          color: "success",
        },
        { root: true }
      );
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.message || "Something went wrong",
          color: "error",
        },
        { root: true }
      );
    }
  },

  //Fetch transactions
  async fetchTransactionsBehind({ commit }) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      const response = await fetchTransactions(1);
      commit("SET_TRANSACTION_DATA", response.data);
      commit("HIDE_PROGRESSBAR", false, { root: true });
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
    }
  },

  //Deposit funds
  async depositFunds({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.depositBtn.load = true;
      rootState.loading.depositBtn.disabled = true;
      await depositFunds(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "PIN time! Verify on your phone.",
          color: "success",
        },
        { root: true }
      );
      setTimeout(() => {
        // Dispatch actionB from moduleB
        dispatch("wallets/fetchFlexiFund", null, { root: true });
      }, 30000);

      setTimeout(() => {
        // Dispatch actionB from moduleB
        dispatch("wallets/fetchTextPay", null, { root: true });
      }, 30000);

      setTimeout(() => {
        // Dispatch actionB from moduleB
        dispatch("wallets/fetchFlexiFund", null, { root: true });
      }, 60000);

      setTimeout(() => {
        // Dispatch actionB from moduleB
        dispatch("wallets/fetchTextPay", null, { root: true });
      }, 60000);
      rootState.loading.depositBtn.load = false;
      rootState.loading.depositBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.message,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.depositBtn.load = false;
      rootState.loading.depositBtn.disabled = false;
    }
  },

  //Withdraw funds
  async withdrawFunds({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.withdrawBtn.load = true;
      rootState.loading.withdrawBtn.disabled = true;
      await withdrawFunds(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Cash on the way! Verify on your phone.",
          color: "primary",
        },
        { root: true }
      );
      setTimeout(() => {
        // Dispatch fetch flexiFund 30sec after deposit initiated
        dispatch("wallets/fetchFlexiFund", null, { root: true });
      }, 30000);

      setTimeout(() => {
        // Dispatch fetch flexiFund1min after deposit initiated
        dispatch("wallets/fetchFlexiFund", null, { root: true });
      }, 60000);
      rootState.loading.withdrawBtn.load = false;
      rootState.loading.withdrawBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      console.log("erro", error);
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.withdrawBtn.load = false;
      rootState.loading.withdrawBtn.disabled = false;
    }
  },

  //Swap from flexiFund to textPay
  async flexiPay({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.swapBtn.load = true;
      rootState.loading.swapBtn.disabled = true;
      await flexiPay(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Balance swap successful.",
          color: "success",
        },
        { root: true }
      );
      // Dispatch fetch flexiFund
      dispatch("wallets/fetchFlexiFund", null, { root: true });
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      console.log("erro", error);
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    }
  },

  //Swap from flexiFund to quickSwap
  async flexiQuick({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.swapBtn.load = true;
      rootState.loading.swapBtn.disabled = true;
      await flexiQuick(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Balance swap successful.",
          color: "success",
        },
        { root: true }
      );
      // Dispatch fetch flexiFund
      dispatch("wallets/fetchFlexiFund", null, { root: true });
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      console.log("erro", error);
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    }
  },

  //Swap from quickSwap to flexiFund
  async quickFlexi({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.swapBtn.load = true;
      rootState.loading.swapBtn.disabled = true;
      await quickFlexi(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Balance swap successful.",
          color: "success",
        },
        { root: true }
      );
      // Dispatch fetch flexiFund
      dispatch("wallets/fetchFlexiFund", null, { root: true });
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      console.log("erro", error);
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    }
  },

  //Swap from shareGain to flexiFund
  async shareFlexi({ commit, rootState, dispatch }, payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      commit("SHOW_PROGRESSBAR", true, { root: true });
      rootState.loading.swapBtn.load = true;
      rootState.loading.swapBtn.disabled = true;
      await shareFlexi(payload);
      commit("HIDE_PROGRESSBAR", false, { root: true });
      commit(
        "SHOW_SNACKBAR",
        {
          text: "Balance swap successful.",
          color: "success",
        },
        { root: true }
      );
      // Dispatch fetch flexiFund
      dispatch("wallets/fetchFlexiFund", null, { root: true });
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    } catch (error) {
      commit("HIDE_PROGRESSBAR", false, { root: true });
      console.log("erro", error);
      commit(
        "SHOW_SNACKBAR",
        {
          text: error.response.data.error,
          color: "error",
        },
        { root: true }
      );
      rootState.loading.swapBtn.load = false;
      rootState.loading.swapBtn.disabled = false;
    }
  },
};
